var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48.725mm",
    height: "60.906mm",
    viewBox: "0 0 48.725 60.906",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.464 -130.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.826 130.96c-12.79 0-24.362 9.8058-24.362 24.971 0 10.11 8.131 22.078 24.362 35.934 16.231-13.856 24.362-25.824 24.362-35.934 0-15.166-11.572-24.971-24.362-24.971zm-0.28556 23.886c-3.3498 0 0.42828 3.6591 0.42828 0.30962 0-3.3498-3.4212-0.046-0.0714-0.046 3.3498 0 0.0242-3.3261 0.0242 0.023 0 3.3498 2.9692-0.28543-0.38063-0.28543z",
    fill: "#898196"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffd42a",
    stroke: "#ffd42a",
    strokeLinecap: "round",
    strokeWidth: 2.2301
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.235,
    y: 151.65,
    width: 7.2771,
    height: 7.2771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.648,
    y: 151.71,
    width: 7.2771,
    height: 7.2771,
    opacity: 0.34864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.822,
    y: 151.58,
    width: 7.2771,
    height: 7.2771,
    opacity: 0.34864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.254,
    y: 162.4,
    width: 7.2771,
    height: 7.2771,
    opacity: 0.34864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.667,
    y: 162.47,
    width: 7.2771,
    height: 7.2771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.841,
    y: 162.34,
    width: 7.2771,
    height: 7.2771,
    opacity: 0.34864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.188,
    y: 141.17,
    width: 7.2771,
    height: 7.2771,
    opacity: 0.34864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.601,
    y: 141.24,
    width: 7.2771,
    height: 7.2771,
    opacity: 0.34864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.775,
    y: 141.11,
    width: 7.2771,
    height: 7.2771
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaster);
export default __webpack_public_path__ + "static/media/raster.2b9674c51d20e4de8291c2a343562463.svg";
export { ForwardRef as ReactComponent };